import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="delete-confirmation"
export default class extends Controller {
  static targets = ["checkbox", "submitButton", "form"];

  connect() {
    this.toggleSubmitButton();
  }

  toggleSubmitButton() {
    const isChecked = this.checkboxTarget.checked;
    this.submitButtonTarget.disabled = !isChecked;
  }
}
